import { selectProseMirrorReferencingSearchType } from './prosemirror-referencing-search.types';

/**
 * Select ProseMirror referencing search
 */
export const selectProseMirrorReferencingSearch: selectProseMirrorReferencingSearchType =
  (state) => state.prosemirror_referencing_search;
